var React = require('react');

function IconStoreLocationsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"}));
}

IconStoreLocationsInline.defaultProps = {"viewBox":"0 0 384 512"};

module.exports = IconStoreLocationsInline;

IconStoreLocationsInline.default = IconStoreLocationsInline;
